import { Coach } from "@/types/page";
import classNames from "@/utils/classNames";
import { coachWithCerts } from "@/utils/fullUserNames";

type CoachReviewDisclosureProps = {
    coach: Coach;
    className?: string;
};

export default function CoachReviewDisclosure({
    coach,
    className = "",
}: CoachReviewDisclosureProps) {
    return (
        <div className={classNames("text-sm text-brand-gray", className)}>
            This review will be posted on {coachWithCerts(coach)}'s profile and
            may also be shown to clients considering coaching.
        </div>
    );
}
